var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{staticStyle:{"textalign":"center"}},[_vm._v(" ©MOTribaliste by Laruche - Middle Office Prestashop ")])}
var staticRenderFns = []

export { render, staticRenderFns }